angular
  .module('cfn')
  .directive('dEmailChangeConfirmPopup', dEmailChangeConfirmPopup);

dEmailChangeConfirmPopup.$inject = [];

function dEmailChangeConfirmPopup() {
  return {
    restrict: 'E',
    scope: {},
    templateUrl: require('./email-change-confirm-popup.html'),
    controller: 'emailChangeConfirmPopupController',
    controllerAs: 'vm',
    bindToController: true,
    link: function (scope, elem, attrs) {}
  };
}